module.exports = __webpack_public_path__ + "static/img/hailiang.4e1eea57.jpeg";